import { bettingSplitsIndex } from '~/apps/product-plus/search-domain/indexes';
import { buildBettingSplitsQuery } from '~/apps/product-plus/search-domain/pipelines/betting-splits/build-query';
import {
  getBettingSplitsBaseFilters,
  getBettingSplitsFacetAttributes,
  getBettingSplitsSearchSettings,
  getBettingSplitsSorting,
} from '~/apps/product-plus/search-domain/pipelines/betting-splits/query-config';
import { transformBettingSplitsResponse } from '~/apps/product-plus/search-domain/pipelines/betting-splits/transform-response';
import { type BettingSplitsESResultBody } from '~/apps/product-plus/search-domain/pipelines/betting-splits/types';
import { type SearchPipelineDefinition, type SearchUiState } from '~/apps/product-plus/search-domain/types';

const resolveBettingSplitsSorting = (context: Parameters<typeof getBettingSplitsSorting>[0]) =>
  getBettingSplitsSorting(context);

export const bettingSplitsPipelineDefinition: SearchPipelineDefinition<SearchUiState, BettingSplitsESResultBody> = {
  buildSearchRequest: buildBettingSplitsQuery,
  facetAttributes: context => getBettingSplitsFacetAttributes(context),
  getBaseFilters: context => getBettingSplitsBaseFilters(context),
  getSearchUiConfig: context => ({
    searchAttributes: getBettingSplitsSearchSettings().search ?? [],
    sorting: () => resolveBettingSplitsSorting(context),
  }),
  getSorting: context => getBettingSplitsSorting(context),
  id: bettingSplitsIndex,
  searchSettings: () => getBettingSplitsSearchSettings(),
  transformResponse: transformBettingSplitsResponse,
};
